import { createResetStateMutation } from '@/helpers';
import { getInitialStateArt } from './state';

export async function setArtCompanies(state, companias) {
   state.artCompanies = companias.map((e) => ({
      value: e.id_compania,
      label: e.nombre,
   }));
}
export async function setEstadosArt(state, estados) {
   state.artEstados = estados.map((e) => ({
      value: e.id_estado,
      label: e.descripcion,
   }));
}

export const resetState = createResetStateMutation(getInitialStateArt);
